import loadable from "../utils/loadable";

export const Welcome = loadable(() => import("./Welcome"), {
  fallback: null,
});
export const Navbar = loadable(() => import("./layout/Navbar"), {
  fallback: null,
});
export const Footer = loadable(() => import("./layout/Footer"), {
  fallback: null,
});
export const TopAnimation = loadable(() => import("./Home/TopAnimation"), {
  fallback: null,
});
export const RoadmapSlider = loadable(() => import("./RoadmapSlider"), {
  fallback: null,
});
export const ImageText = loadable(() => import("./Solution/ImageText"), {
  fallback: null,
});
export const RightSidebarDrawer = loadable(
  () => import("./RightSidebarDrawer"),
  {
    fallback: null,
  },
);
// export const BlogCard = loadable(() => import("./BlogCard"), {
//   fallback: null,
// });
export const DisplayTweets = loadable(() => import("./DisplayTweets"), {
  fallback: null,
});

export const BlogCardSlider = loadable(() => import("./BlogCardSlider"), {
  fallback: null,
});

// Hero Section Home
export const HeroSection = loadable(() => import("./Home/HeroSection"), {
  fallback: null,
});
export const Partners = loadable(() => import("./Home/Partners"), {
  fallback: null,
});
export const PartnersPage = loadable(() => import("./partnerships/page"), {
  fallback: null,
});
export const CentralizedExchange = loadable(
  () => import("./Home/CentralizedExchange"),
  {
    fallback: null,
  },
);
// New Header
export const Header = loadable(() => import("./layout/Header"), {
  fallback: null,
});
// Redefine Future Section
export const RedefineFuture = loadable(() => import("./Home/RedefineFuture"), {
  fallback: null,
});
export const WhatIsMst = loadable(() => import("./Home/WhatIsMst"), {
  fallback: null,
});
export const ProductShowcase = loadable(
  () => import("./Home/ProductShowcase"),
  {
    fallback: null,
  },
);

export const DotGrid = loadable(
  () => import("./Home/ProductShowcase/DotGrid"),
  {
    fallback: null,
  },
);
export const UseCases = loadable(() => import("./Home/UseCases"), {
  fallback: null,
});
export const Explorersection = loadable(
  () => import("./Home/Explorer/Explorersection"),
  {
    fallback: null,
  },
);

export const EcosystemSection = loadable(
  () => import("./Home/EcosystemSection"),
  {
    fallback: null,
  },
);
export const BlogSection = loadable(() => import("./Home/BlogCard"), {
  fallback: null,
});
export const MSTInstitutional = loadable(
  () => import("./Home/MSTInstitutional"),
  {
    fallback: null,
  },
);
export const FAQSection = loadable(() => import("./Home/FAQSection"), {
  fallback: null,
});
// Transactions Section
export const Transactions = loadable(() => import("./Home/Transactions"), {
  fallback: null,
});

export const HeroSectionCommunity = loadable(
  () => import("./Community/HeroSection"),
  {
    fallback: null,
  },
);

export const SectionHeader3D = loadable(() => import("./SectionHeader3D"), {
  fallback: null,
});

export const WhyPartOf = loadable(() => import("./Community/WhyPartOf"), {
  fallback: null,
});

export const WaysYouCan = loadable(() => import("./Community/WaysYouCan"), {
  fallback: null,
});

export const BuildsTogether = loadable(
  () => import("./Community/BuildsTogether"),
  {
    fallback: null,
  },
);

export const WhatYouFind = loadable(() => import("./Community/WhatYouFind"), {
  fallback: null,
});

export const OpportunitiesSection = loadable(
  () => import("./Community/OpportunitiesSection"),
  {
    fallback: null,
  },
);

export const TeamAndPartnersHeroSection = loadable(
  () => import("./TeamAndPartners/HeroSection"),
  {
    fallback: null,
  },
);

export const FoundingMembers = loadable(
  () => import("./TeamAndPartners/FoundingMembers"),
  {
    fallback: null,
  },
);

export const TeamExpertise = loadable(
  () => import("./TeamAndPartners/TeamExpertise"),
  {
    fallback: null,
  },
);

export const LegalAdvisors = loadable(
  () => import("./TeamAndPartners/LegalAdvisors"),
  {
    fallback: null,
  },
);

export const PartnersSection = loadable(
  () => import("./TeamAndPartners/PartnersSection"),
  {
    fallback: null,
  },
);

export const NotificationComponent = loadable(
  () => import("./NotificationComponent"),
  {
    fallback: null,
  },
);

export const YouTubeLinkModal = loadable(
  () => import("./modals/YouTubeLinkModal"),
  {
    fallback: null,
  },
);

export const ClubCommission = loadable(
  () => import("./modals/ClubCommission"),
  {
    fallback: null,
  },
);

export const TrackPageView = loadable(() => import("./TrackPageView"), {
  fallback: null,
});

export const Notifications = loadable(() => import("./Notifications"), {
  fallback: null,
});

export const DynamicTitle = loadable(() => import("./DynamicTitle"), {
  fallback: null,
});

export const UserProfile = loadable(() => import("./Profile"), {
  fallback: null,
});

export const PerspectiveGrid = loadable(() => import("./Perspective"), {
  fallback: null,
});

export const Ambassdor = loadable(() => import("./Ambassador"), {
  fallback: null,
});

export const Cancellation = loadable(() => import("./Cancellation"), {
  fallback: null,
});

export const DashboardCards = loadable(() => import("./DashboardCards"), {
  fallback: null,
});

export const LinkedinTracker = loadable(() => import("./LinkedinTracker"), {
  fallback: null,
});

export const MstBuddy = loadable(() => import("./Home/MstBuddy"), {
  fallback: null,
});

/// draw reward details components
export const DrawHeader = loadable(() => import("./DrawReward/DrawHeader"), {
  fallback: null,
});
export const DrawTabs = loadable(() => import("./DrawReward/DrawTabs"), {
  fallback: null,
});
export const CouponTabs = loadable(() => import("./DrawReward/CouponTabs"), {
  fallback: null,
});
export const CouponTable = loadable(() => import("./DrawReward/CouponTable"), {
  fallback: null,
});
export const PrizeTable = loadable(() => import("./DrawReward/PrizeTable"), {
  fallback: null,
});
export const ScrollToTop = loadable(() => import("./ScrollToTop"), {
  fallback: null,
});

